const generateStrongPassword = () => {
  const upperCase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowerCase = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const specialChars = "!@#$%^&*()_+-=[]{}|;";

  // Ensure one character from each category
  let result =
    upperCase.charAt(Math.floor(Math.random() * upperCase.length)) +
    lowerCase.charAt(Math.floor(Math.random() * lowerCase.length)) +
    numbers.charAt(Math.floor(Math.random() * numbers.length)) +
    specialChars.charAt(Math.floor(Math.random() * specialChars.length));

  // Fill the rest of the password with random characters
  const allChars = upperCase + lowerCase + numbers + specialChars;
  const remainingLength = 12 - result.length;
  for (let i = 0; i < remainingLength; i++) {
    result += allChars.charAt(Math.floor(Math.random() * allChars.length));
  }

  // Shuffle the password to avoid predictable patterns
  return result
    .split("")
    .sort(() => Math.random() - 0.5)
    .join("");
};

export default generateStrongPassword